import qs from 'qs';

export default function(search) {
  return qs.parse(search, { ignoreQueryPrefix: true });
}
